import { Button, Checkbox, Dialog, DialogSurface, Title2, makeStyles, tokens } from "@fluentui/react-components";
import * as React from "react";
import { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useAuth } from "../../AuthContext";
import { SpinnerWithBackdrop } from "../SpinnerWithBackdrop";
import { useEula } from "./useEula";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  title: {
    alignSelf: "center",
    marginTop: "5px",
    marginBottom: "5px",
  },
  markdownstyle: {
    border: "1px" + " solid " + tokens.colorNeutralStroke1,
    overflowY: "auto",
    height: "400px",
    margin: "5px 18px 18px 18px",
    padding: "3px 3px 3px 3px",
  },
  buttonRow: {
    display: "flex",
    flexDirection: "row",
    width: "200px",
    marginTop: "10px",
    marginRight: "18px",
    marginLeft: "18px",
    alignSelf: "flex-end",
    justifyContent: "space-between",
  },
  checkBox: {
    marginLeft: "18px",
  },
});

export const Eula = () => {
  const { eulaData, handleAcceptEula, isLoading } = useEula();
  const [agreed, setAgreed] = useState<boolean>(false);
  const { logout } = useAuth();
  const style = useStyles();

  if (!eulaData) {
    return <SpinnerWithBackdrop />;
  }

  const { eula_id, eula_text } = eulaData;

  return (
    <Dialog modalType="alert" open={true}>
      <DialogSurface className={style.root}>
        <Title2 className={style.title}>End User License Agreement</Title2>
        <div className={style.markdownstyle}>
          <ReactMarkdown components={{ p: "div" }} remarkPlugins={[remarkGfm]}>
            {eula_text}
          </ReactMarkdown>
        </div>
        <Checkbox
          className={style.checkBox}
          checked={agreed}
          onChange={() => setAgreed(!agreed)}
          label="I have read and accepted the terms and conditions of the Eula"
        />
        <span className={style.buttonRow}>
          <Button appearance="secondary" onClick={logout}>
            Decline
          </Button>
          <Button
            disabled={!agreed || isLoading}
            appearance="primary"
            onClick={() => handleAcceptEula(Number(eula_id))}
          >
            Accept
          </Button>
        </span>
      </DialogSurface>
    </Dialog>
  );
};
